import {
  AdminTransactionStateEnum,
  BankTransactionStateEnum,
  PurchaseStateEnum,
  TransferStateEnum
} from '@/services/types/TransactionData';
import { EnumValues } from '@/services/types/EnumValues';

export type AllPossibleTransactionStates =
  | EnumValues<typeof AdminTransactionStateEnum>
  | EnumValues<typeof PurchaseStateEnum>
  | EnumValues<typeof TransferStateEnum>
  | EnumValues<typeof BankTransactionStateEnum>;

export const getTransactionStatus = (state: AllPossibleTransactionStates) => {
  switch (state) {
    case AdminTransactionStateEnum.Pending:
    case PurchaseStateEnum.PreAuth:
    case TransferStateEnum.Pending:
    case BankTransactionStateEnum.Pending:
    case BankTransactionStateEnum.Processing: {
      return 'pending';
    }

    case AdminTransactionStateEnum.Cancelled:
    case PurchaseStateEnum.Declined:
    case TransferStateEnum.Cancelled:
    case BankTransactionStateEnum.Rejected: {
      return 'declined';
    }

    default:
      return 'completed';
  }
};

export const returnTypeofGetTransactionStatus = (
  el: string
): el is ReturnType<typeof getTransactionStatus> => {
  return el === 'pending' || el === 'declined' || el === 'completed';
};
